import React,{Component} from 'react'

import moment from 'moment';

import jump from 'jump.js';

import Wrapper from '../Wrapper';
import Columns from '../Columns';
import LoadMore from '../LoadMore';

import './News.less';

const DEFAULT_THRESHOLD = 5;

const TwitterPost = ({network,created_at,img,id_str,id,text}) => {
  const date = moment(created_at);
  return (
    <a href={`https://twitter.com/statuses/${id_str}`} target="_blank" className={`news-item ${network}`} >
    { img && <img src={img} /> }
    <div className='news-date'>{date.format('DD/MM/YY')}</div>
    {text && <p className='news-content'>&bdquo;{text}&rdquo;</p>}
    </a>
  )
}

const FacebookPost = ({network,created_time,src,message,full_picture,link}) => {
  const date =moment(created_time);
  return (
    <a href={link} target="_blank" className={`news-item ${network}`} >
    { full_picture && <img src={full_picture} /> }
    <div className='news-date'>{date.format('DD/MM/YY')}</div>
    {message && <p className='news-content'>&bdquo;{message}&rdquo;</p>}
    </a>
  )
}

class News extends Component{


  constructor(){
    super();
    this.state = {
      network: 'facebook',
      threshold: DEFAULT_THRESHOLD
    }
  }

  switchType = (network) => {
    this.setState({
      network: network.toLowerCase(),
      threshold: DEFAULT_THRESHOLD
    })
  }

  more = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      threshold: this.state.threshold + DEFAULT_THRESHOLD
    })
  }

  close = () => {
    var newsItems = document.querySelectorAll('.news-item');
    jump(newsItems[DEFAULT_THRESHOLD - 1], {
      callback: () => this.setState({
        threshold: DEFAULT_THRESHOLD
      })
    });


  }

  columnCount = () => {
    const {res} = this.props;

    let ret = 1;

    switch(res){
      case 'xlarge':
        ret = 4;
        break;
      case 'large':
        ret = 3;
        break;
      case 'medium':
        ret = 2;
        break;
      case 'small':
        ret = 1;
        break;
    }

    return ret;
  }

  render(){
    const {network,threshold} = this.state;
    const {data} = this.props;
    // console.log(data);

    return (
      <Wrapper title="Neuigkeiten" menuItems={["Facebook", "Twitter"]} menuAction={this.switchType} {...this.props}>
      <Columns cols={this.columnCount()} >
        {
          data[network].filter((el,idx) => idx < threshold).map((el,idx) => {

            if(network == 'facebook'){
              return <FacebookPost network={network} key={el.id} {...el}/>
            }else{
              return <TwitterPost network={network} key={el.id} {...el}/>
            }

          })
        }
      </Columns>
      <LoadMore action={threshold != DEFAULT_THRESHOLD ? this.close : this.more} type={threshold != DEFAULT_THRESHOLD ? 'close' : 'more'} />
      </Wrapper>
    )
  }
}

export default News



// WEBPACK FOOTER //
// ./src/components/sections/News.js